import { ReturnFunnelStateObject } from '~/scopes/customer-care/resolution/machine/schemas/ReturnFunnel/ReturnFunnel.state'

const { DATA_REMOVAL_INTRO, PICTURES, DESCRIPTION } = ReturnFunnelStateObject
export const ExpressReplacementState = {
  IDLE: {},
  LOADING_FAILED: {
    tags: ['loading_failed'],
    on: {
      RETRY: 'IDLE',
    },
  },
  DATA_REMOVAL_INTRO,
  PICTURES,
  DESCRIPTION,
}
